export const API_ENDPOINTS = {
    signUpClinic: "/clinic/auth/signup",
    signUpUser: "/clinic/auth/user-signup",
    confirmSignUpClinic: "/clinic/auth/signup-confirmation",
    userStatus: "/clinic/auth/user-status",
    callMe: "/clinic/auth/me",
    inviteUser: "/clinic/user/invitation",
    users: "/clinic/user/staff?limit=10&page=1",
    userList: "/clinic/user/staff",
    invitedUser: "/clinic/user/invitation/"
}